/*
  Creator commerce page behavior — port of the approved prototype, adapted to
  run on the real store: adds go to the real cart via /cart/add.js (carrying a
  _creator line property), and Checkout routes through /discount/<CODE> so the
  creator's code auto-applies without the customer typing anything.
*/
(function () {
  var root = document.querySelector('.ccp');
  if (!root) return;

  var cfgEl = document.getElementById('cc-config');
  var cfg = cfgEl ? JSON.parse(cfgEl.textContent) : {};
  var code = cfg.code || '';
  var refParam = cfg.ref || '';

  /* keep the view bar clear of the theme's sticky header */
  function setTopOffset() {
    var h = document.querySelector('header.header, .header-wrapper, header');
    var sticky = 0;
    if (h) {
      var pos = getComputedStyle(h).position;
      if (pos === 'sticky' || pos === 'fixed') sticky = h.offsetHeight;
    }
    root.style.setProperty('--cc-top', sticky + 'px');
  }
  setTopOffset();
  window.addEventListener('resize', setTopOffset);

  /* ---- view + mode switches ---- */
  root.addEventListener('click', function (e) {
    var v = e.target.closest('[data-cc-view]');
    if (v) {
      root.setAttribute('data-view', v.getAttribute('data-cc-view'));
      root.querySelectorAll('.viewswitch button').forEach(function (b) {
        b.classList.toggle('on', b.getAttribute('data-cc-view') === v.getAttribute('data-cc-view'));
      });
      if (v.getAttribute('data-cc-view') === 'answers') hideSticky();
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    var m = e.target.closest('[data-cc-mode]');
    if (m) {
      root.setAttribute('data-mode', m.getAttribute('data-cc-mode'));
      root.querySelectorAll('.modeswitch button').forEach(function (b) {
        b.classList.toggle('on', b.getAttribute('data-cc-mode') === m.getAttribute('data-cc-mode'));
      });
      if (m.getAttribute('data-cc-mode') === 'retail') hideSticky();
      return;
    }
    var q = e.target.closest('.qa-q');
    if (q) { q.parentElement.classList.toggle('open'); return; }

    var scrollBtn = e.target.closest('[data-cc-scroll]');
    if (scrollBtn) {
      var target = root.querySelector(scrollBtn.getAttribute('data-cc-scroll'));
      if (target) target.scrollIntoView({ behavior: 'smooth' });
      return;
    }

    var add = e.target.closest('[data-cc-add]');
    if (add) { e.preventDefault(); addItems([itemFrom(add)], add, false); return; }

    var bulk = e.target.closest('[data-cc-add-all]');
    if (bulk) {
      e.preventDefault();
      var items = [];
      var scopeSel = bulk.getAttribute('data-cc-scope');
      var scope = root.querySelector(scopeSel || '#cc-grid') || root;
      scope.querySelectorAll('[data-cc-add]').forEach(function (el) {
        items.push(itemFrom(el));
      });
      addItems(items, bulk, true);
      return;
    }

    var co = e.target.closest('[data-cc-checkout]');
    if (co) {
      e.preventDefault();
      window.location.href = code
        ? '/discount/' + encodeURIComponent(code) + '?redirect=%2Fcheckout'
        : '/checkout';
    }
  });

  function itemFrom(el) {
    var item = { id: Number(el.getAttribute('data-vid')), quantity: 1 };
    if (refParam) item.properties = { _creator: refParam };
    return { item: item, price: Number(el.getAttribute('data-price') || 0) };
  }

  /* ---- cart state (display only; the real cart holds the truth) ---- */
  var count = 0, total = 0;
  var sticky = root.querySelector('#cc-sticky');
  var label = root.querySelector('#cc-cart-label');

  function money(cents) {
    var n = cents / 100;
    return 'R' + (Number.isInteger(n) ? n : n.toFixed(2));
  }
  function hideSticky() { if (sticky) sticky.classList.remove('show'); }

  function addItems(entries, btn, isBulk) {
    var items = entries.map(function (x) { return x.item; });
    var origText = btn.textContent;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function () {
      entries.forEach(function (x) { count += 1; total += x.price; });
      if (label) {
        label.textContent = count + ' item' + (count > 1 ? 's' : '') + ' · ' + money(total);
      }
      if (!isBulk) {
        btn.textContent = 'Added ✓';
        btn.classList.add('added');
        setTimeout(function () { btn.textContent = origText; btn.classList.remove('added'); }, 1100);
      } else {
        btn.textContent = 'Added ✓ — ' + count + ' items';
      }
      if (sticky) sticky.classList.add('show');
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }).catch(function () {
      btn.textContent = 'Could not add — try again';
      setTimeout(function () { btn.textContent = origText; }, 1600);
    });
  }

  /* ---- Instagram embeds ---- */
  if (root.querySelector('.instagram-media')) {
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://www.instagram.com/embed.js';
    document.body.appendChild(s);
  }
})();
